import React from 'react'
import { DiscType } from '@crystal-eyes/types'
import { Fragment } from 'react'
import classNamesBind from 'classnames/bind'

import {
  fullName,
  mockedProfile,
  profileJobString,
} from '@dashboard/lib/profile'
import Button from '@dashboard/components/Button'
import ProfileImage from '@dashboard/components/ComparisonProfileImage'

import {
  Profile,
  TestResultsProfile,
  ProfileContent,
} from '@dashboard/lib/types'
import { convertDataTags } from '@dashboard/lib/api'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  content?: ProfileContent | null
  profile: Profile | TestResultsProfile | null
  id?: string
  profilePlaceholder?: boolean
  archetypeText?: string
  profileImageOveride?: JSX.Element | null
  signUpCTAText?: string
  paywallButtonLink?: string
}

interface State {}

export default class Overview extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props)
  }

  render() {
    const { profile } = this.props

    if (!profile) return null

    return (
      <div className={classNames('container', 'fadeIn', { noPrint: true })}>
        <div className={css.headerRow}>
          <div className={css.left}>{this.renderProfileImage()}</div>
          <div className={css.right}>
            <div className={css.name}>{fullName(profile)}</div>
            {this.renderJobTitle()}
            {this.renderSummary()}
          </div>
        </div>
      </div>
    )
  }

  renderProfileImage() {
    const { profilePlaceholder, archetypeText, profile } = this.props

    if (!profile) return null
    const discType = profile?.personality?.disc_type
      ? (profile.personality?.disc_type as DiscType)
      : undefined
    return (
      <Fragment>
        <ProfileImage
          photoURL={profile.photo_url}
          size={176}
          profilePlaceholder={profilePlaceholder}
          archetypeText={archetypeText}
          fullName={fullName(profile)}
          discType={discType}
        />
        {this.renderIdealRole()}
      </Fragment>
    )
  }

  renderIdealRole() {
    const { profile, content } = this.props

    if (profile && content) {
      const discType =
        profile && profile.personality ? profile.personality.disc_type : 'empty'
      const archetype =
        profile && profile.personality ? profile.personality.archetype : 'empty'

      return (
        <div className={css.roleWrapper}>
          <div className={classNames('role', discType)}>{archetype}</div>
        </div>
      )
    }
  }

  renderJobTitle() {
    const { profile } = this.props

    if (!profile) return null

    return (
      <div className={css.title}>
        {profileJobString(mockedProfile(profile))}
      </div>
    )
  }

  renderSummary() {
    const { content, id, signUpCTAText, paywallButtonLink, profile } =
      this.props
    const href = `/app/register?profile_id=${id || ''}`

    if (!profile) return null

    if (content) {
      const profileOverview = (content[
        convertDataTags(['profile', 'overview'])
      ] || [])[0]?.text

      return (
        <Fragment>
          <div className={css.summary}>{profileOverview}</div>
          <div className={css.qualities}>{this.renderQualities()}</div>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <div className={css.summary}>
          Sign up to view {profile.first_name}&apos;s personality on Crystal
        </div>
        <Button noMargin href={paywallButtonLink || href}>
          {signUpCTAText || 'Sign up free'}
        </Button>
      </Fragment>
    )
  }

  renderQualities() {
    const { profile, content } = this.props

    if (!content || !profile) return null

    const discType = profile.personality
      ? profile.personality.disc_type
      : 'empty'

    const profileQualities =
      content[convertDataTags(['profile', 'quality'])] || []

    return profileQualities.slice(0, 3).map(quality => {
      return (
        <div key={quality.id} className={classNames('quality', discType)}>
          {quality.text}
        </div>
      )
    })
  }

  register = () => {
    window.location.href = '/app/register?public_assessment'
  }
}
